import { Information } from "../features/simulation/types"
import { TreeItemNode } from "../features/simulation-decisions/types"
import { createTreeNode } from "../features/simulation-decisions/utils"

// Generated actions format from the API
export type ActionCategory = {
  text: string
  categories?: ActionCategory[]
}

// Convert actions array to Information format for Tree component
export const convertActionsToInformation = (actions: ActionCategory[]): Information[] => {
  let idCounter = 1

  const convertItem = (item: ActionCategory): Information => {
    const information: Information = {
      id: idCounter++,
      text: item.text,
      icon: null,
      order: 0,
      actionSentence: null,
      planSentence: null,
      isInfoSearch: 0,
      infoSearchCategory: null,
      measureReference: null,
      categories: []
    }

    if (item.categories && item.categories.length > 0) {
      information.categories = item.categories.map(convertItem)
    }

    return information
  }

  return actions.map(convertItem)
}

// Convert actions to TreeItemNode format directly
export const convertActionsToTreeNodes = (actions: ActionCategory[]): TreeItemNode[] => {
  const informationArray = convertActionsToInformation(actions)
  return informationArray.map(createTreeNode)
}

// Utility to extract all leaf nodes (final actions) from the tree
export const extractLeafActions = (actions: ActionCategory[]): string[] => {
  const leafActions: string[] = []

  const extractLeaves = (item: ActionCategory) => {
    if (!item.categories || item.categories.length === 0) {
      // This is a leaf node (final action)
      leafActions.push(item.text)
    } else {
      // Recursively process children
      item.categories.forEach(extractLeaves)
    }
  }

  actions.forEach(extractLeaves)
  return leafActions
}

// Utility to count total actions in the tree
export const countTotalActions = (actions: ActionCategory[]): number => {
  let count = 0

  const countNodes = (item: ActionCategory) => {
    count++
    if (item.categories) {
      item.categories.forEach(countNodes)
    }
  }

  actions.forEach(countNodes)
  return count
}

// Utility to get actions summary for display
export const getActionsSummary = (actions: ActionCategory[]): {
  totalCategories: number
  totalActions: number
  leafActions: number
} => {
  const leafActions = extractLeafActions(actions)
  const totalActions = countTotalActions(actions)

  return {
    totalCategories: actions.length,
    totalActions,
    leafActions: leafActions.length
  }
}
